<div id="var-item">
    <p>{{text}}</p>
</div>